import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-searchable-multi-select",
  templateUrl: "./searchable-multi-select.component.html",
  styleUrls: ["./searchable-multi-select.component.scss"],
})
export class SearchableMultiSelectComponent implements OnInit {
  @Input() inputData: [] = [];
  @Input() placeholder: string;
  @Input() key;
  @Input() id;
  @Input() inputSelection;
  @Input() dropdownPosition;
  @Input() resetSelection: Subject<boolean>;
  @Output() outputData = new EventEmitter<string[]>();
  selectedData: string[] = [];

  constructor() {}

  ngOnInit(): void {
    this.resetSelection.subscribe((isReset) => {
      if (isReset) {
        this.selectedData = [];
      }
    });

    if (this.inputSelection) {
      this.selectedData = this.inputSelection;
    }
  }

  public fiterData() {
    this.outputData.emit(this.selectedData);
  }

  onRemove(event: any) {
    this.outputData.emit(this.selectedData);
  }

  public getDropdownPosition() {
    return this.dropdownPosition ? this.dropdownPosition : "auto";
  }

  // public onSelectionChange() {
  //   console.log("onSelectionChange(): ", this.selectedData);
  // }

  // compareWith(item, selected) {
  //   console.log("compareWith:item: ", item);
  //   console.log("compareWith:selected: ", selected);

  //   return item[this.id] === selected;
  // }
}
